import { RampPgApiSdk } from '~api/RampPgApiSdk';
import { brandIdValPath, regionIdValPath } from '~constants/Constants';
import { ConfigRepository } from '~repositories/ConfigRepository';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';

// not in use for pincer-iam
export class RampServiceStartedUseCase {
    private configRepository: ConfigRepository;
    private rampPgApiSdk: RampPgApiSdk;

    constructor() {
        this.configRepository = diContainer.get(serviceNames.configRepository);
        this.rampPgApiSdk = diContainer.get(serviceNames.rampPgApiSdk);
    }

    public execute = () => {
        const { config } = this.configRepository.config;
        const businessUnitId = config.businessUnitId || '';

        const baseUrl = window.location.origin;
        this.rampPgApiSdk.setup({
            regionId: config[regionIdValPath] || '',
            brandId: config[brandIdValPath] || '',
            token: config.pgApiTokens?.rampForm || '',
            baseUrl,
            businessUnitId
        });
    };
}
